<template>
  <div>
    <h1 class="title">Schede</h1>

    <CardsSearch />
  </div>
</template>

<script>
import CardsSearch from "@/components/Cards/CardsSearch";

export default {
  name: "cards.view",
  components: { CardsSearch },
};
</script>